import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import useDoctorLogout from 'hooks/communication/useDoctorLogout';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import useLogout from 'hooks/app/useLogout';

export default function LogoutButton(props) {
  const {
    onDoctorLogout,
  } = useDoctorLogout();
  const doctor_info = Recoil.useRecoilValue(AppStore.assets.doctor_info);

  const onLogout = useLogout();

  return (
    <FocusableButton
      {...ex('LogoutButton', props)}
      {...{ onClick: onDoctorLogout({ dr_id: doctor_info?.dr_id }, onLogout) }}
    >
      <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.55556 19C6.12778 19 5.76144 18.8478 5.45656 18.5434C5.15219 18.2386 5 17.8722 5 17.4444V6.55556C5 6.12778 5.15219 5.76144 5.45656 5.45656C5.76144 5.15219 6.12778 5 6.55556 5H12V6.55556H6.55556V17.4444H12V19H6.55556ZM15.1111 15.8889L14.0417 14.7611L16.025 12.7778H9.66667V11.2222H16.025L14.0417 9.23889L15.1111 8.11111L19 12L15.1111 15.8889Z" fill="#667085" />
      </svg>
    </FocusableButton>
  );
}

